import React, { Fragment, useContext } from "react";
import propTypes from "prop-types";
import { IListCustomerItem } from "../../../logic/api";
import styles from "./styles";

import { FiDatabase, FiEdit, FiTrash } from "react-icons/fi";

import ListViewItemCard from "../../../components/cards/ListItemCard/ListItemCard";
import { SessionContext } from "../../../utility/useSession";
import flex from "../../../styles/flex";
import { IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";

const CustomerListItem: React.FunctionComponent<{
  customer: IListCustomerItem;
  onClick: () => void;
  onDelete: () => void;
  onEdit: () => void;
}> = (props) => {
  const session = useContext(SessionContext);
  const { t } = useTranslation();

  if (session.current.site == null) {
    return <Fragment />;
  }

  return (
    <div
      style={{ ...styles.bookingListItem, opacity: props.customer.active == true ? 1 : 0.5 }}
      onClick={() => {
        if (props.onClick != null) {
          props.onClick();
        }
      }}
    >
      <div
        style={{
          position: "absolute",
          textAlign: "center",
          width: 120,
          left: -67,
          bottom: 0,
          height: 15,
          top: 30,
          fontSize: 10,
          overflow: "hidden",
          textOverflow: "ellipsis",
          color: "white",
          transform: "rotate(270deg)",
        }}
      >
        <span>{t("booking.cards.customer")}</span>
      </div>
      <div style={styles.bookingListItemFlex}>
        <ListViewItemCard
          icon={<FiDatabase style={styles.icon} />}
          text={props.customer.name}
          subText={`${props.customer.database} (${props.customer.host}:${props.customer.port})`}
        />

        <ListViewItemCard
          icon={null}
          text={props.customer.clientCode}
          subText={"MySQL 8.0"}
        />
        <div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>
          <IconButton
            onClick={() => {
              props.onEdit();
            }}
          >
            <FiEdit />
          </IconButton>
          <div>
            <small>{t("general.edit")}</small>
          </div>
        </div>
        <div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>
          <IconButton
            onClick={() => {
              props.onDelete();
            }}
          >
            <FiTrash />
          </IconButton>
          <div>
            <small>{t("general.delete")}</small>
          </div>
        </div>


      </div>
    </div>
  );
};

CustomerListItem.propTypes = {
  customer: propTypes.any.isRequired,
  onClick: propTypes.func.isRequired,
  onDelete: propTypes.func.isRequired,
  onEdit: propTypes.func.isRequired,
};

export default CustomerListItem;
